import { render, staticRenderFns } from "./produce.vue?vue&type=template&id=3c6feab2&scoped=true"
import script from "./produce.vue?vue&type=script&lang=js"
export * from "./produce.vue?vue&type=script&lang=js"
import style0 from "./produce.vue?vue&type=style&index=0&id=3c6feab2&prod&lang=less&scoped=true"
import style1 from "./produce.vue?vue&type=style&index=1&id=3c6feab2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6feab2",
  null
  
)

export default component.exports